import React from 'react';
import { Search, ChevronsDown, ChevronsUp, Pencil } from 'lucide-react';

// Barra del Índice del Cuadro de Trabajo: buscador + botón expandir/comprimir todo
// (integración main→dev, epic D1.3). Presentacional.

export default function WorkframeIndexToolbar({
    searchTerm,
    onSearchChange,
    isAllExpanded,
    onToggleExpandAll,
    isEditingTagsMode,
    onToggleEditingTagsMode,
    t,
}) {
    return (
        <div className="wf-search-box">
            <button
                type="button"
                className={`wf-expand-all-btn ${isAllExpanded ? 'expanded' : ''}`}
                onClick={onToggleExpandAll}
                title={isAllExpanded ? t('workframe.index.collapseAll') : t('workframe.index.expandAll')}
            >
                {isAllExpanded ? <ChevronsUp size={14} /> : <ChevronsDown size={14} />}
            </button>
            <Search size={14} className="wf-search-icon" />
            <input
                type="text"
                placeholder={t('workframe.index.searchPlaceholder')}
                value={searchTerm}
                onChange={(e) => onSearchChange(e.target.value)}
                className="wf-search-input"
            />
            <button
                type="button"
                className="wf-expand-all-btn"
                onClick={onToggleEditingTagsMode}
                title={t('workframe.index.editTags', 'Editar etiquetas')}
                style={{ 
                    marginLeft: '4px',
                    background: isEditingTagsMode ? 'rgba(255,255,255,0.1)' : 'transparent',
                    borderRadius: '4px'
                }}
            >
                <Pencil size={13} color={isEditingTagsMode ? '#fff' : '#94a3b8'} />
            </button>
        </div>
    );
}
